<template>
  <div>
    <div class="login-panel">
      <img class="logo" src="../assets/logo.png" alt="" />
      <form action="">
        <br />
        <div class="form-group">
          <label for="email" class="ionput-label">Email</label>
          <input
            type="email"
            class="form-control"
            placeholder="Email"
            v-model="username"
          />
        </div>
        <div class="form-group">
          <label for="password" class="ionput-label">Password</label>
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            v-model="password"
          />
        </div>
        <br />
        <div class="btn-cont">
          <button
            class="btn btn-primary w-100 font-weight-bold"
            @click="login"
            v-if="!isLogginIn"
          >
            Login
          </button>
          <button
            class="btn btn-primary w-100 justify-content-center"
            disabled
            v-if="isLogginIn"
          >
            <loading-component width="30"></loading-component>
          </button>
        </div>
      </form>
    </div>

    <img src="../assets/grad.svg" class="svg-top" />

    <img src="../assets/cruves.svg" class="svg" />
    <div class="powered">
      Made with <span>♥</span> by
      <a href="https://www.sawatechnologies.org">Sawa Technologies</a>
    </div>
  </div>
</template>

<script>
import LoadingComponent from "../components/LoadingComponent";
import { setTimeout } from "timers";
import { HTTP, URLS } from "../network/http";

export default {
  name: "login",
  components: {
    LoadingComponent,
  },
  data() {
    return {
      isLogginIn: false,
      msg: "Hello",
      username: "",
      password: "",
    };
  },
  methods: {
    login() {
      this.isLogginIn = true;
      let ctx = this;
      let data = {
        email: this.username,
        password: this.password,
      };
      HTTP.post(URLS.SUPER_ADMIN.LOGIN, data)
        .then(function (res) {
          const response = res.data.admin;
          console.log(response);
          localStorage.setItem("email", response.email);
          localStorage.setItem("name", response.name);
          localStorage.setItem("id", response.id);
          localStorage.setItem("token", response.token);
          localStorage.setItem("access_level", response.access_level);
          ctx.$toast.success(`Login Successful. Redirecting...`);
          setTimeout(() => {
            ctx.isLogginIn = false;
            ctx.redirect();
          }, 500);
        })
        .catch(function (error) {
          console.log("error in login ");
          console.log(error);
          console.log(error.response.data.message);
          ctx.$toast.error(error.response.data.message || error.message);
          ctx.isLogginIn = false;
          localStorage.removeItem("email");
          localStorage.removeItem("token");
          localStorage.removeItem("id");
          localStorage.removeItem("name");
        });
    },
    redirect() {
      this.$toast.clear();
      if (this.$route.redirectedFrom && this.$route.redirectedFrom.fullPath) {
        this.$router.push(this.$route.redirectedFrom.fullPath || "/admins");
      } else {
        this.$router.push("/admins");
      }
    },
  },
  mounted() {
    console.log("mounted");
    let existingEmail = localStorage.getItem("email");
    console.log("Existing = ", existingEmail);
    if (existingEmail && existingEmail.length > 0) {
      this.username = existingEmail;
    }
  },
};
</script>

<style lang="scss">
.widget {
  margin: 0;
  height: unset;
}

.svg {
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 1;
}

.svg-top {
  width: 100%;
  position: absolute;
  top: 0;
  transform: rotateZ(180deg);
  z-index: 1;
  height: 10rem;
}

.powered {
  color: white;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  font-size: 0.8rem;
  width: 100%;
  text-align: center;
  padding: 1rem;

  span {
    font-size: 1rem;
  }
  a {
    color: white;
    font-weight: bold;
    font-style: italic;
    text-decoration: underline;
  }
}

.login-panel {
  z-index: 2;
  .logo {
    width: 100%;
    border-bottom: 0.5px solid rgba(255, 166, 0, 0.616);
    padding: 1.5rem 5rem 1.5rem 5rem;
  }

  overflow: hidden;

  form {
    .form-group {
      padding: 0rem 1rem;
    }

    .btn {
      height: 4rem;
      border-radius: 0rem;
      font-size: 1rem !important;
      font-weight: 800 !important;
      text-transform: uppercase;
    }
  }
  h1 {
    font-size: 24px;
    margin-top: 30px;
  }
  // padding: 200px 0;
  width: 350px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0rem 0rem 2rem 0rem rgba(128, 128, 128, 0.218);

  .alert {
    opacity: 0;
    position: absolute;
    top: 100px;
    width: 100%;
    &.alert-primary {
    }
    .widget {
      position: absolute;
      right: 5px;
      top: 0;
      margin: 10px;
    }
  }
}
</style>
